import * as Yup from 'yup'
import type { TFunction } from 'i18next'

export const updatePhotoPolygonsSchema = (t: TFunction) => {
  return Yup.array().of(
    Yup.object({
      id: Yup.string().required(),
      building_id: Yup.number()
        .nullable()
        .typeError(t('common:validation_messages.required'))
        .required(t('common:validation_messages.required')),
    }),
  )
}
